<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" rx="7.5" fill="#833E93"/>
        <path d="M4.69476 11.1997L10.6666 5.22786" stroke="white" stroke-width="1.01494" stroke-linecap="round"/>
        <path d="M5.86664 5.04245H10.7583" stroke="white" stroke-linecap="round"/>
        <path d="M10.7643 5.04245V9.84245" stroke="white" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'article-icon'
}
</script>